import { Component, Input, OnInit } from '@angular/core';
import { AyaPriceListProgramDate } from '../../models';
import { NgForOf } from '@angular/common';
import { TableModule } from 'primeng/table';
import { OrdinalDatePipe } from '@lx/shared/ui/pipes';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-aya-program-dates',
  templateUrl: './aya-program-dates.component.html',
  styleUrls: ['./aya-program-dates.component.scss', './print-aya-program-dates.component.scss'],
  imports: [NgForOf, TableModule, OrdinalDatePipe],
})
export class AyaProgramDatesComponent implements OnInit {
  @Input() programDatesBySchool: AyaPriceListProgramDate[] | undefined;

  protected endDatesColumns: number[] = [];
  protected durationIndexes: number[] = [];

  ngOnInit(): void {
    const durations = (this.programDatesBySchool ?? [])
      .flatMap((programDate) => Object.values(programDate.endDates ?? {}))
      .map((endDateInfo) => endDateInfo?.duration)
      .filter((duration): duration is number => typeof duration === 'number');

    this.endDatesColumns = Array.from(new Set(durations)).sort((a, b) => a - b);

    // Create an array of indexes for durations to be used in the template
    this.durationIndexes = this.endDatesColumns.map((_, i) => i);
  }
}
